declare global {
  interface Window {
    Telegram?: {
      WebApp: {
        ready: () => void;
        expand: () => void;
        close: () => void;
        initData: string;
        initDataUnsafe: {
          user?: {
            id: number;
            first_name: string;
            last_name?: string;
            username?: string;
            language_code?: string;
          };
        };
        themeParams: Record<string, string>;
        colorScheme: "light" | "dark";
        setHeaderColor: (color: string) => void;
        setBackgroundColor: (color: string) => void;
        HapticFeedback: {
          impactOccurred: (style: "light" | "medium" | "heavy" | "rigid" | "soft") => void;
          notificationOccurred: (type: "error" | "success" | "warning") => void;
          selectionChanged: () => void;
        };
        MainButton: {
          text: string;
          color: string;
          textColor: string;
          isVisible: boolean;
          isActive: boolean;
          show: () => void;
          hide: () => void;
          onClick: (callback: () => void) => void;
          offClick: (callback: () => void) => void;
          setText: (text: string) => void;
          enable: () => void;
          disable: () => void;
        };
        BackButton: {
          isVisible: boolean;
          show: () => void;
          hide: () => void;
          onClick: (callback: () => void) => void;
          offClick: (callback: () => void) => void;
        };
      };
    };
  }
}

export function getWebApp() {
  return window.Telegram?.WebApp;
}

export function initTelegram() {
  const webapp = getWebApp();
  if (webapp) {
    webapp.ready();
    webapp.expand();
    webapp.setHeaderColor("#0f0f23");
    webapp.setBackgroundColor("#0f0f23");
  }
}

export function getInitData(): string {
  return getWebApp()?.initData ?? "";
}

export function getTelegramUser() {
  return getWebApp()?.initDataUnsafe?.user;
}
